<template>
  <div style="width: 100%" v-if="showReadMore">
    <div class="info-faq-container" v-if="content.normal">
      <div class="info-sections heading" style="width: 100%">
        <span v-html="content.normal"></span>
        <a v-show="!readMore && content.extra" @click="handleReadMore" class="read-more" style="display: flex; cursor: pointer; align-items: center;">
          <span v-show="content.extra"><img src="@/assets/images/arrow-down.svg" /></span>
          <span style="color: #000"> Read more</span>
        </a>

        <div v-show="readMore">
          <span v-html="content.extra"></span>
          <a @click="handleReadMore" class="read-more" style="text-decoration: none !important; display: flex; cursor: pointer; align-items: center;" v-show="content.extra">
            <span class="read-more__rotate"><img src="@/assets/images/arrow-down.svg" style="rotate: 180deg" /></span>
          <span style="color: #000"> Read less</span>
          </a>
        </div>
      </div>
    </div>
    <p v-else v-html="description"></p>
</div>
  <div style="width:100%" v-else>
    <div class="info-faq-container" >
      <div class="faq-content__que" v-html="convertUrlsToLocale(description, baseUrl, locale)"></div>
  </div>
</div>

</template>
<script setup lang="ts">
const readMore = ref<boolean>(false);
const content = ref({
  normal: '',
  extra: ''
});

const props = defineProps<{
  description: string;
  showReadMore?: boolean
}>();


const handleReadMore = () => {
  readMore.value = !readMore.value;
};

const runtimeConfig = useRuntimeConfig();
const baseUrl = runtimeConfig.public.BASE_URL;
import { useI18n } from 'vue-i18n';
const { locale } = useI18n();
import { convertUrlsToLocale } from '~/utils/getLangUrl';

const parseSeoDescription = (htmlString: string): void => {
  if (!htmlString?.trim()) {
    content.value = { normal: '', extra: '' };
    return;
  }

  try {
    const doc = new DOMParser().parseFromString(htmlString, 'text/html');

    const firstHeading = doc.querySelector('h1, h2')?.outerHTML ?? '';
    const firstParagraph = doc.querySelector('p')?.outerHTML ?? '';

    if (!firstHeading && !firstParagraph) {
      content.value = { normal: htmlString, extra: '' };
      return;
    }

    const normal = `${firstHeading}${firstParagraph}`.trim();
    const extra = htmlString
      .replace(firstHeading, '')
      .replace(firstParagraph, '')
      .trim();

    content.value = { normal, extra };
  } catch (error) {
    console.error('Error parsing HTML:', error);
    content.value = { normal: htmlString, extra: '' };
  }
}

onMounted(() => {
  parseSeoDescription(props.description);
});
</script>
<style lang="scss">
  @import "@/assets/scss/components/listing/_listing-faq.scss";
  @import "@/assets/scss/components/home/_heading.scss";
.info-faq-container{
  p {
  font-size: 15px;
  line-height: 1.5;
  font-family: "Roboto", sans-serif;
  margin-bottom: 20px;
}
}

</style>

